module.exports = __webpack_public_path__ + "img/40_69_012_380.53279ca3.jpg";